/* eslint-disable react/prop-types */

import { colors } from '@lmc/common/constants'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { ChartLogList } from '../../../../components/generic'
import Highcharts from './Highcharts'

const LineChart = (props) => {
  // Use categoryColor
  const { mock, yAxisLabel, series, logs, type } = props

  const chartData = (data, key) =>
    _(data)
      .filter((d) => !d.deleted)
      .map((log) => [
        Date.parse(dayjs(log.timeLogged).toString()),
        parseFloat(_.get(log, `measurements.${key}.value`))
      ])
      .filter((d) => _.isFinite(d[1])) // triggers error for non numeric values
      .sortBy('0')
      .value()

  const chartColors = [colors.purple, colors.green]

  let chartSeries
  if (series && series.length) {
    chartSeries = series.map(({ type, label }, index) => ({
      name: label,
      color: chartColors[index],
      data: chartData(logs, type),
      marker: {
        lineColor: chartColors[index]
      }
    }))
  } else {
    chartSeries = [
      {
        name: yAxisLabel,
        color: chartColors[0],
        data: chartData(logs, type)
      }
    ]
  }

  const config = {
    ...props,
    chartType: 'spline',
    series: chartSeries,
    plotOptions: {
      // eslint-disable-next-line react/destructuring-assignment
      ...props?.plotOptions,
      turboThreshold: 10000
    }
  }

  return logs && logs.length ? (
    <div>
      <Highcharts config={config} />
      <ChartLogList mock={mock} logs={logs} />
    </div>
  ) : (
    <EmptyState
      title="Shoot... No data to show you"
      description="No logs to display"
      icon={<NoDataIcon />}
    />
  )
}

LineChart.propTypes = {
  title: PropTypes.string.isRequired
}

export default LineChart
